<template>
  <div class="trialCostListPage">
    <div class="bg">
      <div class="content-box">
        <el-table class="table" ref="dragTable" :data="dataList" v-loading="loading"
          element-loading-background="rgba(255, 255, 255, 0.8)" border width="100%" fit 
          :header-cell-style="{
            background: '#ECF2FE',
            borderColor: '#999999',
          }" 
          :cell-style="{
            borderColor: '#999999',
          }">

          <el-table-column align="center" v-for="headerItem in headerList" :key="headerItem">
            <template #header>
              <div class="header-title" @click="sortDo(headerItem.title)">{{ headerItem.title }}</div>
            </template>
            <template #default="scope">
              <div :class="headerItem.title == headerList[0].title ? 'table-first' : 'table-other'" @click="pushTrial(headerItem.title, scope.row)">
                <span class="span1" v-show="headerItem.title == headerList[0].title">{{ scope.$index + 1 }}</span>
               <span :class="headerItem.title == headerList[0].title ? 'span2': 'span3'" > {{
                  getItemValue(scope.row, headerItem)
                }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="page-cost">
          Sum: <span>{{ totalPrice }}</span> (￥)
        </div>
        <div class="page-bg">
          <div class="page-left">共 {{ totalCount }} 项数据</div>
          <el-pagination class="page-right" background layout="prev, pager, next" :total="totalCount" :page-size="pageSie"
            :current-page="currentPage" @current-change="currentDo">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getQueryMetricsBySheet } from "@/request/api";
import { BenchMarkType, getCostValueByRun, pushToNewWindowByParams } from "@/utils/common"
import moment from "moment";
import {
  ResourceType,
  RunnerStatus,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
export default {
  name: "trialCostListPage",
  data() {
    return {
      allDataList: [],
      headerList: [
        {
          title: "TRIAL LIST",
          key: "name",
        },
        {
          title: "STATUS",
          key: "statusStr",
        },
        {
          title: "CREATEDAT",
          key: "createTime",
        },
        {
          title: "PRICE(￥)",
          key: "cost",
        }
      ],
      currentPage: 1,
      pageSie: 10,
      resourceType: ResourceType.TRIAL,
      loading: false,
      totalCount: 0,
      totalPrice: 0,
      selectHeaderTitle: '',
      isUpperClick: false,
    };
  },

  components: {
  },
  computed: {
    dataList() {
      const list = this.allDataList.slice((this.currentPage - 1) * this.pageSie, this.currentPage * this.pageSie)
      return list;
    },
  },
  methods: {
    pushTrial(title, model) {
      if (title == this.headerList[0].title) {
        pushToNewWindowByParams("Trial", { id: model.trialId })
      }
    },
    getItemValue(model, headerItem) {
      if (headerItem.key == "cost") {
        const value = model[headerItem.key]
        return Math.round(value * 100) / 100
      }
      return model[headerItem.key] ? model[headerItem.key] : '/'
    },
    sortDo(title) {
      if (this.selectHeaderTitle != title) {
        this.selectHeaderTitle = title
        this.isUpperClick = true
      } else {
        this.isUpperClick = false
      }
      if (this.selectHeaderTitle == this.headerList[1].title) {
        if (this.isUpperClick) {
          this.allDataList.sort((m1, m2) => {
            return m2.status - m1.status
          })
        } else {
          this.allDataList.sort((m1, m2) => {
            return m1.status - m2.status
          })
        }
      } else if (this.selectHeaderTitle == this.headerList[2].title) {
        if (this.isUpperClick) {
          this.allDataList.sort((m1, m2) => {
            return m2.timeStamp - m1.timeStamp
          })
        } else {
          this.allDataList.sort((m1, m2) => {
            return m1.timeStamp - m2.timeStamp
          })
        }
      } else if (this.selectHeaderTitle == this.headerList[3].title) {
        if (this.isUpperClick) {
          this.allDataList.sort((m1, m2) => {
            return m2.cost - m1.cost
          })
        } else {
          this.allDataList.sort((m1, m2) => {
            return m1.cost - m2.cost
          })
        }
      }
      if (!this.isUpperClick) {
        this.selectHeaderTitle = ""
      }
    },
    currentDo(index) {
      this.currentPage = index;
    },
    createData() {
      this.pageSie = screen.availHeight <= 875 ? 5 : 10;
      this.currentPage = 1;
      this.allDataList = []
      this.getAllDataList();
    },
    getStatusTitle(status) {
      let statusTitle = "";
      if (status == RunnerStatus.DONE) {
        statusTitle = "Done";
      } else if (status == RunnerStatus.ERROR) {
        statusTitle = "Error";
      } else if (status == RunnerStatus.RUNNING) {
        statusTitle = "Running";
      } else if (status == RunnerStatus.WAITING) {
        statusTitle = "Waiting";
      } else if (status == RunnerStatus.TIMEOUT) {
        statusTitle = "Timeout";
      } else if (status == RunnerStatus.CANCELED) {
        statusTitle = "Timeout";
      }
      return statusTitle;
    },
    async getResourceData() {
      this.loading = true;
      const sheetId = this.$route.params.id
      const userId = this.$route.params.userId
      const list = await getQueryMetricsBySheet(sheetId, false);
      console.log("getQueryMetricsBySheet list = ", list);
      this.totalCount = list.length
      let totalCost = 0
      let createTime = "/"
      for (const item of list) {
        if (userId == item.trialinfo?.committer) {
          if (item.trialinfo?.creationtime) {
            createTime = moment((item.trialinfo?.creationtime?.seconds + item.trialinfo?.creationtime?.nanos / Math.pow(10, 9)) * 1000).format("YYYY-MM-DD HH:mm:ss");  
          }
          let cost = getCostValueByRun(item.trialinfo?.runnersList, item.trialinfo?.machinesensitive)
          totalCost += cost
          if (cost > 0) {
            const model = {
              name: item.name,
              trialId: item.trialid,
              status: item.trialinfo?.status,
              statusStr: this.getStatusTitle(item.trialinfo?.status),
              createTime: createTime,
              timeStamp: item.trialinfo?.creationtime?.seconds,
              cost: cost,
            }
            this.allDataList.push(model)
          }
        }
      }
      this.loading = false
      this.totalPrice = Math.round(totalCost * 100) / 100
    },
    async getAllDataList() {
      const title = BenchMarkType.Trial.toLocaleUpperCase();
      document.title = `aqua.${title.toLocaleLowerCase()}list`
      this.getResourceData()
    },
  },
  created() {
    this.createData();
  },
};
</script>
<style lang='less' scoped>
.trialCostListPage {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}

.bg {
  padding: 35px 0px 10px 0px;
  background-color: #f5f5f5;
  max-width: 1800px;
  width: calc(100% - 60px);
  min-width: 900px;
  margin: 0 auto;
}

.content-box {
  padding: 35px 53px;
  position: relative;
  background-color: #ffffff;
  border-radius: 3px;
  position: relative;
}

.table {
  width: 100%;
  border: 1px solid #999999;
}

.header-title {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.table-other {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
}

.table-first {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
  height: 45px;
  display: flex;
  align-items: center;
  // justify-content: center;
  white-space: pre-wrap;
  text-align: left;
  .span1 {
    color: #999999;
    font-size: 15px;
    font-weight: 500;
  }
  .span2 {
    font-size: 15px;
    margin-left: 10px;
    font-weight: 500;
    color: #0052d9;
    cursor: pointer;
  }
  .span3 {
    color: #383838;
  }
}

.page-cost {
  color: #333;
  font-size: 15px;
  display: flex;
  margin-top: 10px;
  padding-right: 10px;
  justify-content: flex-end;
  span {
    font-weight: 500;
    color: #0052d9;
    padding-right: 10px;
  }
}

.page-bg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
  .page-right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

:deep(.el-table th) {
  user-select: initial !important;
}

</style>